import React, { useState } from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import { Chevron } from '../../SVGs/svg.imports.js';

const SummaryLogTable = () => {

  const { matrixData, questionLog, answerLog } = useStore(state =>({
    matrixData: state.matrixData,
    questionLog: state.questionLog,
    answerLog: state.answerLog,
  }), shallow);

  const [tableShow, setTableShow] = useState(true);

  const toggleSummaryTable = () => {
    setTableShow(!tableShow);
  }

  const summaryRightHeading = matrixData['resultsPageRightHeading'];

  return (
   <div>
     <h4 className="summary-logs_heading">{summaryRightHeading}</h4>
    <button onClick={toggleSummaryTable} className={`swt-button summary-logs_button collapsible ${tableShow ? '' : 'active'}`}>
      <span className="summary-logs_accordion-heading">{summaryRightHeading}</span>
      <span className="summary-logs-chevron"><Chevron /></span>
    </button>
    <div className={`summary-logs_answers ${tableShow ? 'hide':''}`}>
      {questionLog.map((question, index) => {
        return (
          <div key={index} className="summary-logs-group">
            <div className="summary-logs_question ">{question}</div>
            <div className="summary-logs_answer ">Your answer:  {answerLog[index]}</div>
          </div>
        )
      })}
    </div>
   </div> 
  )
}


export default SummaryLogTable;